import { useMemo } from 'react';
import { Routes, useLocation } from 'react-router-dom';
import { getCustomDomainEventSlug, toVirtualPathname } from '../utils/customDomainRouting';

/**
 * Routes wrapper for branded custom domains. Uses a virtual location so /sebas matches
 * /{event_slug}/sebas while the browser URL stays unchanged.
 */
export default function CustomDomainRoutes({ children }) {
  const location = useLocation();
  const customDomainSlug = useMemo(() => getCustomDomainEventSlug(), []);

  const routingLocation = useMemo(() => {
    if (!customDomainSlug) return location;
    const pathname = toVirtualPathname(location.pathname, customDomainSlug);
    if (pathname === location.pathname) return location;
    return { ...location, pathname };
  }, [location, customDomainSlug]);

  return <Routes location={routingLocation}>{children}</Routes>;
}
